import { Amount, AmountSkeleton } from 'components/shared/Amount/Amount';
import { BlockOrientationFormGroup } from 'components/shared/FormGroup';
import { FC, useContext } from 'react';
import { useIntl } from 'react-intl';

import { AddonMainFormContext } from '../AddonMainForm.context';

interface OwnProps {
  totalNumberOfAccumulationDays?: number;
  visible: boolean;
}
export const TotalNumberOfAccumulationDays: FC<OwnProps> = ({
  totalNumberOfAccumulationDays: dailyNumberOfShares,
  visible,
}) => {
  const intl = useIntl();
  const { isLoading } = useContext(AddonMainFormContext);

  if (!visible) {
    return null;
  }

  return (
    <BlockOrientationFormGroup inputId="totalNumberOfAccumulationDays" label="addon.totalNumberOfAccumulationDays">
      {!isLoading && (
        <Amount
          e2e="addon-investment-details-total-number-of-accumulation-days"
          id="addonTotalNumberOfAccumulationDays"
          placeholder={intl.formatMessage({ id: 'addon.totalNumberOfAccumulationDays' })}
          value={dailyNumberOfShares}
          isDisabled
        />
      )}
      {isLoading && <AmountSkeleton />}
    </BlockOrientationFormGroup>
  );
};

TotalNumberOfAccumulationDays.displayName = 'TotalNumberOfAccumulationDays';
